// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3uLmV","row":"ProcedureTreatmentSummary_row__8KEqn"};